/* eslint-disable no-unused-vars */
import {
  put,
  all,
  take,
  takeEvery,
  fork,
  select,
  call,
  delay
} from "redux-saga/effects";
import * as R from "ramda";
// import { apiCall } from "App/Data/sagas";
// import {
//   getPortalUser,
//   updatePortalUser
// } from "redux/modules/portal/user/actions";

import {
  EVENT_SWITCHER_DROPDOWN_ID,
  FORM_ID,
  PROFILE_DROPDOWN
} from "./constants";

import { registerError } from "redux/modules/errors/actions";

import { debounce } from "utils/General/sagas";

import { getSettings } from "redux/modules/portal/settings/actions";

import { isFetching, portalUser } from "redux/modules/portal/user/selectors";
import { eventDetails, messages } from "redux/modules/portal/selectors";
import { user, getCredentials } from "redux/modules/user/selectors";
import { settings } from "redux/modules/portal/settings/selectors";

import { actions } from "./model";

import * as PortalSelectors from "redux/modules/portal/selectors";

import { actions as FormActions } from "ui-kit/Form/model";

import { getEditedField } from "./selectors";

import { push } from "react-router-redux";

import { navigateTo } from "utils/General";

const init = function*() {
  // load details

  // const portalUser = yield select(portalUser);
  // const eventDetails = yield select(eventDetails);

  const eventDetailss = yield select(eventDetails);
  const portalUserr = yield select(portalUser);
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const loadEventOptions = function*({ payload: search, meta: { callback } }) {
  try {
    const portal = yield select(PortalSelectors.portal);
    const filteredEvents = R.filter(
      e => (e.name ? e.name.toLowerCase().includes(search) : false),
      portal.events || []
    );

    const options = R.map(el => ({
      value: R.prop("id", el),
      label: R.prop("name", el),
      ...el
    }))(filteredEvents);

    callback(options);
  } catch (error) {
    yield all([
      put(
        registerError([
          {
            system: error,
            user: "An error occurred fetching options for async dropdown"
          }
        ])
      )
    ]);
  }
};

const fieldUpdate = function*({ id, fieldId }) {
  const newValue = yield select(getEditedField, {
    instanceId: id,
    fieldId
  });

  if (fieldId === EVENT_SWITCHER_DROPDOWN_ID) {
    const [value] = newValue;
    if (!R.isEmpty(value)) {
      yield call(navigateTo, `/portals/${value.slug}/${value.uuid}`);
    }
    return;
  }

  if (fieldId === PROFILE_DROPDOWN) {
    // const [value] = newValue;
    // here put the differente options and call to generators to do something
    yield put(
      FormActions.setFieldValue([0], {
        meta: {
          fieldId,
          instanceId: id
        }
      })
    );
    return;
  }
  //

  // yield put(actions.updateField({ field: fieldId, value: processedValue }));
};

const watchUpdateFields = function*() {
  for (;;) {
    const {
      meta: { instanceId, fieldId }
    } = yield take(FormActions.setFieldValue.type);
    if (instanceId === FORM_ID) {
      yield call(fieldUpdate, {
        id: instanceId,
        fieldId
      });
    }
  }
};

const watchLoadAsyncDropdownEventOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === EVENT_SWITCHER_DROPDOWN_ID,
  loadEventOptions,
  250
);

const rootSaga = function*() {
  yield all([
    fork(watchInit),
    fork(watchLoadAsyncDropdownEventOptions),
    fork(watchUpdateFields)
  ]);
};

export default rootSaga;
